import React, { SVGProps } from "react";

type Props = Pick<SVGProps<SVGSVGElement>, 'width' | 'height'>;
const SvgCaretUp: React.FC<Props> = (props: Props) => (
  <svg
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    height={props.height}
    width={props.width}
    viewBox="0 0 9 7"
  >
    <path
      d="M8.904 6.134 4.735 1.086a.309.309 0 0 0-.47 0L.096 6.134c-.155.188-.015.464.235.464h8.338c.25 0 .39-.276.235-.464Z"
      fill="#4C4D4F"
    />
  </svg>
);
export default SvgCaretUp;

